import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mapUserProfileDataToServer } from "mappers";
import { usersService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateUserProfileMutation = ({ onSuccess }) => {
	const dispatch = useDispatch();

	return useMutation(
		({ formValues }: { formValues: { [key: string]: any } }) => {
			return usersService.updateUserProfileData(
				mapUserProfileDataToServer(formValues),
			);
		},
		{
			onSuccess: (_data, { formValues }) => {
				onSuccess?.(formValues);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateUserProfileMutation;
